<template>
  <div id="app">
    <Header />
        <div class="navs">
      <ul>
        <li><a href="#zh">综合</a></li>
        <li><a href="#zyjy">职业教育</a></li>
        <li><a href="#zj">早教</a></li>
        <li><a href="#yyl">语言类</a></li>
        <li><a href="#gdjy">高等教育</a></li>
        <li><a href="#steam">steam教育</a></li>
        <li><a href="#k12">K12</a></li>
        <li><a href="#jyfws">教育服务商</a></li>
      </ul>
    </div>
    <Main />
    <Footer />
  </div>
</template>

<script>
import Header from "./views/Header";
import Main from "./views/Main";
import Footer from "./views/Footer";

export default {
  name: "App",
  data() {
    return {
      popupShow: false,
      count: 6,
      loading: false,
    };
  },
  components: {
    Header,
    Main,
    Footer,
  },
  computed: {
    noMore() {
      return this.count >= 8;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  mounted() {
    setTimeout(() => {
      this.popupShow = true;
    }, 3000);
  },
  methods: {
    popupClose() {
      this.popupShow = false;
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.count += 1;
        this.loading = false;
      }, 2000);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

html,
body,
ul,
p,
textarea,
input,
#app {
  margin: 0;
  padding: 0;
}
body {
  background: #f1f4f9;
}
li {
  list-style: none;
}
h1,
h2,
h3 {
  font-weight: normal;
  margin: 0;
}
a {
  text-decoration: none;
  transition: all 0.5s ease;
}
img {
  display: block;
}
textarea {
  outline: none;
}
input {
  border: none;
}

/* 导航 */
.navs {
  width: 1300px;
  margin: 0 auto 60px;
  background: #0e7a63;
}
.navs ul {
  display: flex;
}
.navs li {
  margin:auto;
  padding: 0 10px;
  height:40px;
  line-height: 40px;
  font-size: 20px;
}
.navs li a {
  color: #fff;
}
.navs li:hover {
  background: #14b34f;
}
.load-box .el-tabs__item.is-active {
  color: #0e7a63;
}
.load-box .el-tabs__item:hover {
    color: #0e7a63;
    cursor: pointer;
}
.shadow-box {
  background: #fff;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

#app .search .el-input__inner {
  color: #fff;
  background-color: inherit;
  text-align: center;
}

.popup-bg {
  width: 1200px;
  opacity: 0.75;
  position: fixed;
  left: calc(50% - 600px);
  bottom: 0;
  z-index: 999;
  transition: all 0.5s ease-in-out;
}
.popup-bg:hover {
  opacity: 1;
}
.popup-box {
  position: relative;
}
.popup-box img {
  width: 100%;
}
.popup-close {
  background: #111;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  transition: all 0.5s ease-in-out;
}
.popup-close:hover {
  background: #0e7a63;
}
.popup-close i {
  color: #fff;
}

@media (max-width: 1100px) {
  .popup-bg {
    display: none;
  }
  .navs {
    width: 100%;
  }
  .navs ul {
    display: flex;
    flex-wrap: wrap;
  }
  .navs li {
    width: 115px;
    margin: 5px;
    padding:0;
    text-align: center;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
  }
}
</style>
